export const isOnlyNumber = /^[0-9]+$/
export const isContractCode = /([0-9])+-[A-Za-z0-9]{1}$/ // Valid example: 000000000000000000-0
export const isOnlyLetter = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]+$/
export const isSymbol = /^[A-Za-z0-9]{0,1}[A-Za-z]{0,3}[0-9]{0,1}[A-Za-z0-9]{0,3}$/
